export default __webpack_public_path__ + "static/media/link.d5fbe7e5.svg";